import { useCallback } from 'react';
import { API_ROUTERS } from '../data';
import { scoreMapping } from '../services';
import { useRequest } from './useRequest';

export const useScore = () => {
  const { authRequest } = useRequest();

  const fetchScore = useCallback(
    async (memberId?: string | number) => {
      try {
        const url = memberId ? API_ROUTERS.MEMBER_SCORE(memberId) : API_ROUTERS.SCORE;
        const { data } = await authRequest({ method: 'get', url });
        return scoreMapping(data);
      } catch (e) {}
    },
    [authRequest],
  );

  return { fetchScore };
};
